/**
 * Elephant Desks - Accessibility Dev (Dawn 6.0.2)
 * Stabilizes Lighthouse by neutralizing problematic ARIA from apps
 * and adding iframe titles even when apps inject late.
 */
(function () {
  function fixBuddhaMenuAria() {
    document.querySelectorAll(
      'ul.horizontal-mega-menu[role="menu"], ul.horizontal-mega-menu[role="menubar"]'
    ).forEach(function (ul) {
      ul.removeAttribute("role");
      ul.removeAttribute("aria-activedescendant");
      ul.removeAttribute("aria-orientation");
      ul.querySelectorAll('[role="menu"], [role="menubar"], [role="menuitem"]').forEach(function (el) {
        el.removeAttribute("role");
      });
    });
  }

  function fixIframeTitles() {
    // Give a title to any iframe missing one (covers Cozy + other apps)
    document.querySelectorAll("iframe").forEach(function (iframe) {
      if (!iframe.getAttribute("title")) {
        // Prefer a meaningful title when we can infer it from src
        var src = (iframe.getAttribute("src") || "").toLowerCase();
        var title = "Embedded content";
        if (src.includes("cozy")) title = "Elephant Desks video gallery";
        if (src.includes("youtube")) title = "YouTube video";
        if (src.includes("vimeo")) title = "Vimeo video";
        iframe.setAttribute("title", title);
      }
    });
  }

  function runFixes() {
    fixBuddhaMenuAria();
    fixIframeTitles();
  }

  // Run once after DOM parsed (best balance)
  document.addEventListener("DOMContentLoaded", function () {
    runFixes();

    // Watch only for newly added nodes (low overhead)
    var observer = new MutationObserver(function (mutations) {
      var needsRun = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          needsRun = true;
          break;
        }
      }
      if (needsRun) runFixes();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Stop after 4 seconds (enough for apps to inject)
    setTimeout(function () {
      observer.disconnect();
    }, 4000);
  });
})();
